import React from 'react';
import { StyleSheet, Text, View, ScrollView, TextInput, TouchableWithoutFeedback } from 'react-native';
import MyText from './MyText';

export default function PDF({ navigation }) {
  return (
    <ScrollView contentContainerStyle={{flexShrink: 0, flexGrow: 1}}>
        <MyText>PDF</MyText>
    </ScrollView>
  );
}

const styles = StyleSheet.create({

});
